export default {
  status: [
    {required: true, message: 'Please select the transaction status.'}
  ],
  response: []
}
